import { Component, OnInit, ViewChild, ElementRef, Input, ViewChildren, EventEmitter, Renderer2, ViewEncapsulation, QueryList, ComponentFactoryResolver, ComponentFactory, ComponentRef, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin, Observable, Subject } from 'rxjs';

import { StateService, AuthService, AuctionService, AuctionLotService, MyAuctionLotService } from '../../../services';
import { } from '../../../models';
import { FormFunctions } from '../../../functions';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { } from '../../../shared/modals';
import { ModalConfirmBidsComponent, ModalViewBidImagesComponent } from '../../modals';
import { bool } from 'aws-sdk/clients/signer';
import { fadeAnimation } from 'src/app/shared/animations';
import { delay, filter, map, takeUntil, tap } from 'rxjs/operators';
import { AuctionLotItemComponent } from 'src/app/components';

@Component({
    selector: 'page-watch-list-bid',
    styleUrls: ['./page-watch-list-bid.component.scss'],
    templateUrl: './page-watch-list-bid.component.html',
    animations: [fadeAnimation],
    encapsulation: ViewEncapsulation.None,
})
export class PageWatchListBidComponent implements OnInit {
    processing: boolean = false;
    initialized: boolean = false;
    searching: boolean = false;

    checkboxes: any;
    IsFavouriteItemClicked: boolean = false;
    bids: any[] = [];
    selectedBids: any[] = [];

    showAll: boolean = true;
    showWatching: boolean = true;
    showWinning: boolean = true;
    showOutbid: boolean = true;
    showHiddenBids: boolean = false;

    elementsToHide: any[] = [];
    IsShowWinningBidsClicked: boolean = false;
    IsShowOutbidBidsClicked: boolean = false;

    @ViewChildren("bidCard") bidCards: QueryList<AuctionLotItemComponent>;
    @ViewChild("list", { read: ViewContainerRef }) container: ViewContainerRef;

    get selectedBidCards(): any[] {
        return this.bidCards?.filter(x => x.IsSelected) ?? [];
    }

    get closedBidCards(): any[] {
        return this.bidCards?.filter(x => !x.LotIsBiddable) ?? [];
    }

    constructor(
        public router: Router,
        private activatedRoute: ActivatedRoute,
        public stateService: StateService,
        private modalService: NgbModal,
        public authService: AuthService,
        public auctionService: AuctionService,
        public auctionLotService: AuctionLotService,
        public myAuctionLotService: MyAuctionLotService,
        public formFunctions: FormFunctions,
        private elem: ElementRef,
        private resolver: ComponentFactoryResolver,
        private renderer: Renderer2) {
        var me = this;
    }

    ngOnInit() {
        var me = this;

        // Wait until the default auction is loaded
        me.initialized = false;

        me.auctionService.CurrentAuction().subscribe(data => {
            if (me.activatedRoute.snapshot.params.auctionId) {
                // console.log('Setting specific Auctionid', me.activatedRoute.snapshot.params.auctionId);
                me.auctionLotService.auctionId = Number(me.activatedRoute.snapshot.params.auctionId);
                me.OnAuctionChange(false);
            } else {
                me.OnAuctionChange(true);
            }
            me.initialized = true;
        });

        me.myAuctionLotService.myAuctionLots$.subscribe(data => {
            me.setTestData();
            setTimeout(() => {
                //console.log('myAuctionLots$', me.myAuctionLotService.myAuctionLots, me.bidCards)
                //me.bidCards = me.bidCards;
                //me.bidCards = me.bidCards.sort((a,b) => allBids.indexOf(a.lot.Id) - allBids.indexOf(b.lot.Id));
            }, 0)
        })
    }

    setTestData() {
        // let me = this;
        // var test = true;
        // if (test) {
        //     var auction = me.auctionService.auctions?.find(x => x.Id == me.auctionLotService.auctionId);
        //     if (auction) {
        //         //console.log('Test auction end date');
        //         auction.CloseDate = new Date(new Date().getTime() - (320 * 1000));
        //     }
        //     var testLot = me.myAuctionLotService.myAuctionLots?.find(x => x.AuctionLotId == 387931);
        //     if (testLot) {
        //         //console.log('Test lot bid date', testLot);
        //         testLot.BidDate = new Date();
        //         testLot.AuctionLot.CurrentBidDateTime = new Date();
        //     }
        // }
    }

    ngAfterViewInit() {
        let me = this;
        const rowChange$: Observable<QueryList<AuctionLotItemComponent>> = me.bidCards.changes;

        const indexOfRow = (row: AuctionLotItemComponent) => {
            return row.LotIsBiddable ? -1 : 1;
        };

        const sortedRows$ = rowChange$.pipe(
            tap(rows => me.setTestData()),
            map(rows => me.bidCards.toArray()),
            filter(rows => rows.length > 1),
            // map(rows => rows.sort((a, b) => a.LotIsBiddable === b.LotIsBiddable ? (a.lot?.EstimatePrice > b.lot?.EstimatePrice ? -1 : 1) : a.LotIsBiddable ? -1 : 1)),
            map(rows => rows.sort((a, b) => Number(a.lot.LotNumber ?? 0) > Number(b.lot.LotNumber ?? 0) ? 1 : 0)),
        );

        sortedRows$
            .pipe(takeUntil(me.destroySub))
            .subscribe(sortedRows => {
                //console.log('sortedRows$.subscribe', sortedRows, sortedRows.map(x => x.lot.Id));
                me.bidCards.reset(sortedRows)
                var sortedIds = sortedRows.map(x => x.lot.Id)
                //console.log('sortedIds', sortedIds);
                // me.myAuctionLotService.myAuctionLots.sort((a, b) => sortedIds.indexOf(a.AuctionLotId) - sortedIds.indexOf(b.AuctionLotId))
                me.myAuctionLotService.myAuctionLots.sort((a, b) => Number(a.AuctionLot.LotNumber ?? 0) > Number(b.AuctionLot.LotNumber ?? 0) ? 1 : 0)
            });
    }

    destroySub = new Subject();

    LoadData() {
        let me = this;
    }

    OnAuctionChange(redirect: boolean) {
        let me = this;
        // console.log('OnAuctionChange', me.auctionLotService.auctionId, redirect);

        me.myAuctionLotService.auctionId = me.auctionLotService.auctionId;
        //me.myAuctionLotService.UpdateList();

        me.LoadData();
        me.auctionLotService.AuctionChanged();
        me.auctionLotService.Initialize();

        if (redirect) me.router.navigate(['/bids', me.auctionLotService.auctionId || me.auctionService.auction.Id]);
    }

    get checklist() {
        return [this.showOutbid, this.showWatching, this.showWinning];
    }

    checkUncheckAll() {
        for (var i = 0; i < this.checklist.length; i++) {
            this.showOutbid = this.showAll;
            this.showWatching = this.showAll;
            this.showWinning = this.showAll;
        }
    }

    // Check All Checkbox Checked
    isAllSelected() {
        this.showAll = this.checklist.every(function (item: boolean) {
            return item == true;
        })
    }

    ViewImages() {
        let me = this;
        const modalRef = me.modalService.open(ModalViewBidImagesComponent, {
            scrollable: true,
            size: 'lg'
        });
    }

    Visible(bid) {
        if (!this.showHiddenBids && bid.IsHidden) return false;
        if (this.showAll) return true;
        if (!this.showWatching && bid.WatchingOnly) return false;
        if (!this.showWinning && bid.IsWinning) return false;
        if (!this.showOutbid && !bid.WatchingOnly && !bid.IsWinning) return false;
        return true;
    }

    Format(arr: string[]) {
        return arr.filter(Boolean).join(", ");
    }

    onSelect(event, bid: any) {
        let me = this;
    }

    ResetBidCards() {
        let me = this;
        // Reset their status when we come back
        me.bidCards.forEach(bidCard => {
            bidCard.ResetStatus();
            bidCard.newBidAmt = bidCard.MyAuctionLot.SavedBidAmount;
        });
    }

    modalRef: NgbModalRef;
    ReviewAndConfirmBids() {
        let me = this;
        const modalRef = me.modalService.open(ModalConfirmBidsComponent, {
            scrollable: true,
            size: 'lg'
        });

        // console.log('Opening ReviewAndConfirmBids modal', modalRef.componentInstance);

        const factory: ComponentFactory<AuctionLotItemComponent> = this.resolver.resolveComponentFactory(AuctionLotItemComponent);
        var container = me.container;

        let bids = [];
        me.selectedBidCards.forEach(bidCard => {
            let newBidCard: ComponentRef<AuctionLotItemComponent> = container.createComponent(factory);
            newBidCard.instance.lot = bidCard.lot;
            newBidCard.instance.newBidAmt = bidCard.newBidAmt;
            newBidCard.instance.oldBidAmt = bidCard.oldBidAmt;
            newBidCard.instance.NewBidAmountValidated = bidCard.NewBidAmountValidated;
            bids.push(newBidCard.instance);
        });
        modalRef.componentInstance.bids = bids;

        // console.log('ReviewAndConfirmBids', modalRef.componentInstance.bids);

        // If they 'complete' an action in the modal, reset the bid cards here when they come back.
        // Otherwise they've 'cancelled' their action and we shouldn't clear their $ values.
        modalRef.componentInstance.save.subscribe(x => {
            // console.log('modalRef.save');
            me.ResetBidCards();
        });

        modalRef.result.then((result) => {

            if (me.activatedRoute.snapshot.params.auctionId) {
                // console.log('Setting specific Auctionid', me.activatedRoute.snapshot.params.auctionId);
                me.auctionLotService.auctionId = Number(me.activatedRoute.snapshot.params.auctionId);
                me.OnAuctionChange(false);
            } else {
                me.OnAuctionChange(true);
            }

        });
    }
}
